import React from 'react';
import PropTypes from 'prop-types';
import RadioInputButton from './radioInputButton.js';

const RadioInput = props => {
  const {
    className,
    id,
    name,
    buttons,
    onChange,
    value,
    label,
    wrapperClass,
    disabled
  } = props;

  return (
    <fieldset
      className={wrapperClass}
    >
      <legend
        id={name}
        htmlFor={id}
      >
        {label}
      </legend>
      <div className={className} onChange={onChange}>
        {buttons.map((button, idx) => (
          <RadioInputButton
            key={idx}
            id={button.id}
            name={name}
            value={button.value}
            checked={button.value === value}
            label={button.label}
            readOnly={true}
            disabled={disabled}
          >
          </RadioInputButton>
        ))}
      </div>
    </fieldset>
  );
};

RadioInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  legend: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  disabled: PropTypes.bool
};

export default RadioInput;
